import { render } from "./ComplaintId.vue?vue&type=template&id=050b8229&scoped=true&ts=true"
import script from "./ComplaintId.vue?vue&type=script&lang=ts"
export * from "./ComplaintId.vue?vue&type=script&lang=ts"

import "./ComplaintId.vue?vue&type=style&index=0&id=050b8229&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050b8229"]])

export default __exports__